exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".module.domains_campaigns_edit{height:100%}.module.domains_campaigns_edit .edit-campaign{height:100%}.module.domains_campaigns_edit .sw-v2-campaign-builder{height:100%}", ""]);
